import { CSVReader } from 'react-papaparse';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class UploadCsv extends Component {
  static propTypes = {
    handleOnDrop: PropTypes.func.isRequired,
    handleOnError: PropTypes.func.isRequired,
    handleOnRemoveFile: PropTypes.func.isRequired,
  };

  render() {
    return (
      <CSVReader
        onDrop={this.props.handleOnDrop}
        onError={this.props.handleOnError}
        addRemoveButton
        onRemoveFile={this.props.handleOnRemoveFile}
        config={{ header: true, dynamicTyping: true, skipEmptyLines: true }}
      >
        <span>Drop CSV file here or click to upload.</span>
      </CSVReader>
    );
  }
}

export default UploadCsv;
